<script>
import { mapGetters } from "vuex";
import {
  colorMap,
  colors,
} from "@/components/modules/new-dashboard/components/organizations-by-region/shared";
import OrganizationsByRegionLabels from "@/components/modules/new-dashboard/components/organizations-by-region/organizations-by-region-labels.vue";
import MapChart from "@/shared/charts/map/map-chart.vue";
import DashboardSpinner from "@/components/modules/new-dashboard/components/dashboard-spinner.vue";

export default {
  name: "OrganizationsByRegionMapWidget",
  components: {DashboardSpinner, MapChart, OrganizationsByRegionLabels },
  data: function() {
    return {
      formatedOrganizationsByCountry: [],
      legend: [1, 2, 3],
      config: {
        width: 400,
        height: 280,
        marginTop: 0,
        //marginRight: 15,
        marginBottom: 0,
        //marginLeft: 100,
        axisLabelSpacePercentage: 0,
      },
    };
  },
  mounted() {
    this.formatOrganizationsByCountry()
  },
  watch: {
    'getOrganizationsByCountry': {
 handler:     function() {
        this.formatOrganizationsByCountry();
      },deep:true
    }
  },
  computed: {
    colorMap() {
      return colorMap;
    },
    colors() {
      return colors;
    },
    ...mapGetters([
      "getOrganizationsByCountry",
      "getSelectedRegionInWidget",
      "getOrganizationsByRegion",
    ]),
  },
  methods: {
    formatOrganizationsByCountry: function () {
      var max = Math.round(
        Math.max(...this.getOrganizationsByCountry.data.map((c) => c.count)) *
          1.5
      );
      var min = Math.round(
        Math.min(...this.getOrganizationsByCountry.data.map((c) => c.count)) *
          0.5
      );

      this.legend = [
        Math.max(min, 3),
        Math.max(Math.round((min + max) / 2), 10),
        Math.max(max, 20),
      ];
     this.formatedOrganizationsByCountry = this.getOrganizationsByCountry.data.map((country) => {
        return {
          latitude: +country._id.latitude ?? 0,
          longitude: +country._id.longitude ?? 0,
          label: country._id.country,
          value: +country.count,
        };
      });
    },

    getCountries: function () {
      if (!this.getSelectedRegionInWidget) {
        return [];
      }

      var countriesForRegion = this.getOrganizationsByRegion.data.filter(
        (region) => {
          var key = region._id?.region?._id ?? 'Sin Region'
          return key  === this.getSelectedRegionInWidget
        }
      );
      var totals = countriesForRegion.reduce(
        (previousValue, currentValue) => previousValue + +currentValue.count,
        0
      );
      return countriesForRegion.map((country) => {
        return {
          id: country._id.country._id,
          value: country.count,
          name: this.$t( country._id.country.country),
          originalName: country._id.country.country,
          percentage: (100 * (country.count / totals)).toFixed(0),
        };
      });
    },

    onSelectRegion: function (regionId) {
      //dashboardStore.setSelectedRegionInWidget(regionId);
    },

    onSelectCountry: function (regionId) {
      //dashboardStore.setSelectedRegionInWidget(null);
    },
  },
};
</script>

<template>
  <div>
    <dashboard-spinner :height="280" v-if="getOrganizationsByRegion.loading"></dashboard-spinner>

    <organizations-by-region-labels
      v-if="getCountries().length"
      style="
        position: absolute;
        left: -190px;
        height: calc(100% - 55px);
        width: calc(100% + 190px);
        overflow: auto;
        top: 45px;
      "
      :colors="colors"
      :chart-data="getCountries()"
      :on-select-region="onSelectCountry"
    />
    <div
      v-if="!getOrganizationsByCountry.loading"
      style="cursor: pointer"
      class="public-institutions-by-region-map"
      :style="{ opacity: getSelectedRegionInWidget ? '0.3' : '1' }"
    >
      <map-chart
        :chart-data="formatedOrganizationsByCountry"
        :values-to-show="legend"
        :color="colors"
        :config="config"
        :color-map="colorMap"
        :parent-height="false"
      />
    </div>
  </div>
</template>

<style scoped>
.loading {
  height: 236px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
